import axiosSecure from "./axiosSecure";
import {
  InputUserUpdate,
  OutputUserUpdate,
  OutputWhoAmi,
} from "./Users/users.interface";

export const callWhoami = async (accessToken: string) => {
  const response =
    await axiosSecure(accessToken).post<OutputWhoAmi>("/users/whoami");
  return response.data;
};

export const callUserUpdate = async (
  accessToken: string,
  data: InputUserUpdate,
) => {
  const response = await axiosSecure(accessToken).put<OutputUserUpdate>(
    "/users/update",
    data,
  );
  return response.data;
};
